module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point2_2-840d6cd1e8358dc3ee41011703782337.jpg";